export const getMediaCompletion = (length: number = 0, customSteps: Record<number, number> | null = null): number => {
  if (customSteps) {
    const step = customSteps[length];
    return step !== undefined ? step : 100;
  }

  return length === 0 ? 0 : 100;
};
